import { Phone, Mail, Globe } from "lucide-react";
import { CONTACT } from "../data/content";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { SectionTitle } from "./Brand";
import { Reveal } from "./Reveal";

const Contact = () => (
    <section id="contact" data-testid="contact-section" className="relative py-24 sm:py-32">
        <div className="halo pointer-events-none absolute left-1/2 top-0 h-[26rem] w-[36rem] -translate-x-1/2 rounded-full opacity-70" />
        <div className="relative mx-auto max-w-4xl px-4 sm:px-6">
            <Reveal>
                <SectionTitle
                    eyebrow="Contact & devis sur mesure"
                    title="Une demande particulière ?"
                    sub="Besoin d'un devis sur mesure ou d'une prestation spécifique ? Contactez-nous directement."
                />
            </Reveal>

            <div className="grid gap-4 sm:grid-cols-2">
                <Reveal delay={0.05}>
                    <a
                        href={CONTACT.whatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="contact-whatsapp-button"
                        className="card-line glow-soft group flex items-center gap-4 rounded-3xl bg-panel p-6 transition-shadow duration-500 hover:glow-strong"
                    >
                        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-neon text-noir transition-transform duration-300 group-hover:scale-110">
                            <WhatsAppIcon size={24} />
                        </span>
                        <span>
                            <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                                <WhatsAppIcon size={13} className="text-neon" /> WhatsApp
                            </span>
                            <span className="block font-display text-lg font-bold text-white">
                                {CONTACT.phoneDisplay}
                            </span>
                        </span>
                    </a>
                </Reveal>
                <Reveal delay={0.12}>
                    <a
                        href={CONTACT.phoneHref}
                        data-testid="contact-phone-button"
                        className="card-line glow-soft group flex items-center gap-4 rounded-3xl bg-panel p-6 transition-shadow duration-500 hover:glow-strong"
                    >
                        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-neon/40 text-neon transition-transform duration-300 group-hover:scale-110">
                            <Phone size={22} />
                        </span>
                        <span>
                            <span className="block text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                                Téléphone
                            </span>
                            <span className="block font-display text-lg font-bold text-white">
                                {CONTACT.phoneDisplay}
                            </span>
                        </span>
                    </a>
                </Reveal>
                <Reveal delay={0.19}>
                    <a
                        href={`mailto:${CONTACT.email}`}
                        data-testid="contact-email-button"
                        className="card-line glow-soft group flex items-center gap-4 rounded-3xl bg-panel p-6 transition-shadow duration-500 hover:glow-strong"
                    >
                        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-neon/40 text-neon transition-transform duration-300 group-hover:scale-110">
                            <Mail size={22} />
                        </span>
                        <span>
                            <span className="block text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                                E-mail
                            </span>
                            <span className="block font-display text-lg font-bold text-white">
                                {CONTACT.email}
                            </span>
                        </span>
                    </a>
                </Reveal>
                <Reveal delay={0.26}>
                    <div
                        data-testid="contact-website-card"
                        className="card-line glow-soft flex items-center gap-4 rounded-3xl bg-panel p-6"
                    >
                        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-neon/40 text-neon">
                            <Globe size={22} />
                        </span>
                        <span>
                            <span className="block text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                                Site
                            </span>
                            <span className="block font-display text-lg font-bold text-white">
                                {CONTACT.site}
                            </span>
                        </span>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);

export default Contact;
